import React, { useEffect, useState } from "react";
import TableHeader from "../../Components/TableHeader";
import Heading from "../../tailwindUI/Heading";
import Pagination from "../../tailwindUI/Pagination";
import Table from "../../tailwindUI/Table";
import classes from "../../module.css/ViewStockDetails.module.css";
import Navbar from "../../tailwindUI/Navbar";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataNotFound from "../../Components/DataNotFound";
import ExcelDownload from "../../Components/ExcelDownload/ExcelDownload";
import Tab from "../../tailwindUI/Tab";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Resize,
  Group,
  Sort,
  ColumnMenu,
  Filter,
  Toolbar,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-react-grids";
import { registerLicense } from "@syncfusion/ej2-base";

const groupOptions = { showGroupedColumn: true };
const filterSettings = { type: "CheckBox" };
const toolbarOptions = ["ExcelExport", "PdfExport", "CsvExport", "Search"];
let gridInstance;
let flag = true;
function dataBound() {
  if (flag) {
    gridInstance.toolbarModule.toolbar.hideItem(2, true);
    flag = false;
  }
}

function toolbarClick(args) {
  switch (args.item.text) {
    case "PDF Export":
      gridInstance.pdfExport();
      break;
    case "Excel Export":
      gridInstance.excelExport();
      break;
    case "CSV Export":
      gridInstance.csvExport();
      break;
  }
}

const AdminChangeLogreport = () => {
  const getUsersData = JSON.parse(localStorage.getItem("userdata"));
  const getUsersToken = localStorage.getItem("UserToken");
  const edpFilter = getUsersData?.filter((edp) => edp.UserRole === "EDP");
  const edpToken = edpFilter[0].UserToken;
  // console.log(getUsersToken,"jdlkud");
  const { BookingID } = useParams();
  const location = useLocation();
  const pathname = window.location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const term = queryParams.get("term");

  const valuesofterm = () => {
    return term || "";
  };

  let navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [pageResults, setPageResults] = useState(0);
  const [searchTerm, setSearchTerm] = useState(valuesofterm());

  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [sort, setSort] = useState("ASC");
  const [orderSort, setOrderSort] = useState("ASC");
  const [modelSort, setModelSort] = useState("ASC");
  const [variantSort, setVariantSort] = useState("ASC");
  const [feulSort, setFeulSort] = useState("ASC");
  const [colorSort, setColorSort] = useState("ASC");
  const [carStatus, setCarStatus] = useState("ASC");
  const [allExcelData, setAllExcelData] = useState([]);
  const page = parseInt(queryParams.get("page") ? queryParams.get("page") : 1);

  const [tabNum, setTabNum] = useState(0);
  const [maxpages, setMaxpages] = useState(1);
  const [tabname, setTabname] = useState("Allocated");

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/syros", { replace: true });
  };

  useEffect(() => {
    fetchAdminChangeLogs();
  }, [searchTerm, page, tabname]);

  const dateTemplate = (props) => {
    const createdAt = new Date(props.CreatedAt);
    const year = createdAt.getFullYear();
    const month = String(createdAt.getMonth() + 1).padStart(2, "0");
    const day = String(createdAt.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Formats as YYYY-MM-DD
  };

  // Template for displaying the Time
  const timeTemplate = (props) => {
    const createdAt = new Date(props.CreatedAt);
    const hours = String(createdAt.getHours()).padStart(2, "0");
    const minutes = String(createdAt.getMinutes()).padStart(2, "0");
    const seconds = String(createdAt.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`; // Formats as HH:MM:SS
  };

  const fetchAdminChangeLogs = async () => {
    try {
      setLoading(true);

      const apiEndpoint = "/api/v1/stockone/srm/GetSRMChangeLogList"; // Single API endpoint

      const response = await fetch(`${global.apiBaseUrl}${apiEndpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: global.authToken,
        },
        body: JSON.stringify({
          UserToken: getUsersToken,
          BookingId: BookingID,
        }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.status_code === 200 && data.status === "Success") {
        if (data.message === "data found successfully") {
          setTableData(data.data || []);
          setCount(data.datacount || 0);
          setPageResults(data.data?.length || 0);
          setAllExcelData(data.alldata || []);
          console.log(tableData, "ALL THE DATA");
        } else {
          setTableData([]);
          setCount(0);
          setPageResults(0);
        }
      } else if (data.message.includes("Invalid User Token")) {
        LogOut();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching stock details:", error);
    }
  };

  const BreadCrumb = {
    pagename: "Booking Change Logs",
    pagePath: "/syros-booking-report",
    pagename1: "",
    pagePath1: "",
  };

  const BreadCrumHomeLink = "/syros-dashboard";

  return (
    <>
      <Navbar navbarType={"admin navbar"} />
      <div className={classes.maincontainer}>
        <div className="mb-4">
          <Heading
            headingType={"Page Headings"}
            headingText={"Booking Change Logs"}
            BreadCrumb={BreadCrumb}
            BreadCrumHomeLink={BreadCrumHomeLink}
          />
        </div>

        <div className={classes.table}>
          {loading ? (
            <img
              src="../assets/loadingGif.gif"
              alt="loading"
              className={classes.loader}
            />
          ) : (
            <>
              <div className="control-pane">
                <div className="control-section">
                  <GridComponent
                    dataSource={tableData}
                    height="500"
                    allowPaging={true}
                    allowResizing={true}
                    allowGrouping={true}
                    allowSorting={true}
                    allowFiltering={true}
                    showColumnMenu={true}
                    groupSettings={groupOptions}
                    filterSettings={filterSettings}
                    toolbar={toolbarOptions}
                    allowExcelExport={true}
                    allowPdfExport={true}
                    // toolbarClick={toolbarClick.bind(this)}
                    ref={(grid) => (gridInstance = grid)}
                    dataBound={dataBound.bind(this)}
                    pageSettings={{ pageCount: 4, pageSizes: true }}
                    autoFit={true}

                    // pageSettings={{ pageCount: 4, pageSize: 30 }}
                  >
                    <ColumnsDirective>
                      <ColumnDirective
                        field="Name"
                        headerText="Updated By"
                        width="200"
                        textAlign="center"
                      ></ColumnDirective>
                      <ColumnDirective
                        field="CreatedAt"
                        headerText="Date"
                        width="200"
                        textAlign="center"
                        template={dateTemplate}
                      />
                      <ColumnDirective
                        field="CreatedAt"
                        headerText="Time"
                        width="200"
                        textAlign="center"
                        template={timeTemplate}
                      />
                      <ColumnDirective
                        field="ChangedData"
                        headerText="Value Added"
                        width="600"
                        textAlign="start"
                      ></ColumnDirective>
                    </ColumnsDirective>
                    <Inject
                      services={[
                        Resize,
                        Group,
                        Sort,
                        ColumnMenu,
                        Filter,
                        Page,
                        Toolbar,
                        ExcelExport,
                        PdfExport,
                      ]}
                    />
                  </GridComponent>
                </div>
              </div>
            </>
          )}
        </div>
        {maxpages > 1 && (
          <div className={classes.pagination}>
            <Pagination maxPages={maxpages} />
          </div>
        )}
      </div>
    </>
  );
};

export default AdminChangeLogreport;
